/** @file The production Pose2D origin (spec §8.1), the default of the CLI and the client setup files. */

/** https origin, no trailing slash. */
export const PRODUCTION_URL = 'https://pose2d.zilo-game.dev';
